module.exports = __webpack_public_path__ + "img/CaptureGDH-min.a216e5c4.png";